import { QueryClient } from "@tanstack/react-query";
import { occFetch } from "./api/occ/occFetch";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = (error as Error & { status?: number }).status;
        return status !== 401 && failureCount < 1;
      },
      staleTime: 30_000,
      queryFn: ({ queryKey }) => {
        const url = String(queryKey[0]);
        return occFetch(url).then((r) => {
          if (!r.ok) {
            const error = new Error(`OCC fetch failed: ${r.status}`);
            (error as Error & { status: number }).status = r.status;
            throw error;
          }
          return r.json();
        });
      },
    },
  },
});
